import {Grid} from '@logistics-frontend/blocks'
import React from 'react'

import {useGreyClasses} from './classes'

type Props = {
  startText: React.ReactNode
  endText?: React.ReactNode
}

const Info: React.FC<Props> = ({startText, endText}) => {
  const classes = useGreyClasses()

  return (
    <Grid alignItems="center" spacing={2} container>
      <Grid item xs>
        {startText}
      </Grid>
      {endText && (
        <Grid classes={classes} item>
          {endText}
        </Grid>
      )}
    </Grid>
  )
}

export default Info
